export const FAQ_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    question: "",
    answer: "<p>Describe this highlight. Long answers are truncated with a “View more” toggle.</p>",
    background_color: "#FFFFFF",
    priority: 1,
  },

  FAQ_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Main heading — wrap words in { } to highlight them, e.g. Explore {More}",
      value: "Explore More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Explore {More}",
      required: false,
      defaultValue: "Explore More",
    },
    {
      fieldName: "title_text_color",
      label: "Heading text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "title_1",
      label: "Subtitle (below heading)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Optional supporting line",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_1_color",
      label: "Subtitle text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "section_background_color",
      label: "Section background (outer) — used when no background image",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "section_background_image",
      label: "Section background image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Wide image behind the cards",
      filterCategory: "images",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_background_image_alt",
      label: "Background image alt text (accessibility)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image if meaningful; leave empty if decorative",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Accent color (heading underline)",
      value: "#130554",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#130554",
    },
    {
      fieldName: "section_color",
      label: "“View more / View less” link color (also the { } heading highlight)",
      value: "#130554",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#130554",
    },
    {
      fieldName: "status",
      label: "FAQ status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Group name (internal — not shown; cards render as a flat list)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Highlights",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "order_index",
      label: "Display order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Group status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  FAQ_TABLE_FIELDS_CONFIG: [
    {
      header: "Card title (optional)",
      fieldName: "question",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Optional heading above the card body",
      required: false,
    },
    {
      header: "Card title color",
      fieldName: "question_text_color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Card body (rich text)",
      fieldName: "answer",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter the card content",
      required: true,
    },
    {
      header: "Card body text color",
      fieldName: "answer_text_color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Card background color",
      fieldName: "background_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      required: true,
    },
  ],
};
